import React, { useEffect, useState, useRef } from 'react';
import ByobCollectionCard from './ByobCollectionCard.jsx';
import ByobTray from './ByobTray.jsx';
import ByobProductCards from './ByobProductCards.jsx';

const BuildYourOwnSetMain = () => {
  const [collectionsData, setCollectionsData] = useState({ collections: [] });
  const [trayData, setTrayData] = useState([]);
  
  // Fetch the data when the component mounts 
  useEffect(() => {
    setCollectionsData(window.collectionData || { collections: [] });
  }, []);

  useEffect(() => {
    console.log("Collection Data" ,collectionsData);
  }, [collectionsData]);  

  useEffect(() => {
    setTrayData([]);
  }, []);

  useEffect(() => {
    console.log("Tray Data" ,trayData);
  }, [trayData]);

  const handleAddToTray = (product) => {
    setTrayData((prevTrayData) => [...prevTrayData, product])
  }

  const handleRemoveFromTray = (index) => {
    setTrayData((prevTrayData) => {
      const newTrayData = [...prevTrayData]
      newTrayData.splice(index, 1)
      return newTrayData
    })
  }

  const [isOverlappingHeader, setIsOverlappingHeader] = useState(false);
  const [isOverlappingFooter, setIsOverlappingFooter] = useState(false);
  const headerRef = useRef(null);
  const mainRef = useRef(null);
  const footerRef = useRef(null);
  const [topPosition, setTopPosition] = useState(58);
  const [reachedContainerEnd, setReachedContainerEnd] = useState(false);

  useEffect(() => {
    const header = document.querySelector('#SiteHeader');
    const main = document.querySelector('#build-your-own-set-main');
    const tray = document.querySelector('#byob-tray-container');

    if (header && main && tray) {
      headerRef.current = header;
      mainRef.current = main;
    }

    function checkOverlap() {
      if (headerRef.current && mainRef.current && tray) {
        const headerRect = headerRef.current.getBoundingClientRect();
        const mainRect = mainRef.current.getBoundingClientRect();
        const trayRect = tray.getBoundingClientRect();
        const isMobile = window.innerWidth < 768;
        
        // Check header overlap
        setIsOverlappingHeader(!(headerRect.right < mainRect.left || 
                               headerRect.left > mainRect.right || 
                               headerRect.bottom < mainRect.top || 
                               headerRect.top > mainRect.bottom));

        if (isMobile) {
          // On mobile, check if the tray is within viewport bottom
          const viewportHeight = window.innerHeight;
          const buffer = 20;
          setReachedContainerEnd(trayRect.bottom + buffer > viewportHeight);
        } else {
          // Desktop behavior remains the same
          const mainBottom = mainRect.bottom;
          const trayBottom = trayRect.bottom;
          const buffer = 20;

          if (mainBottom <= trayBottom + buffer) {
            setReachedContainerEnd(true);
            setTopPosition(mainBottom - trayRect.height - buffer);
          } else {
            setReachedContainerEnd(false);
            setTopPosition(58);
          }
        }
      }
    }

    // Initial check
    checkOverlap();

    // Add scroll event listener
    window.addEventListener('scroll', checkOverlap);
    window.addEventListener('resize', checkOverlap);

    // Cleanup
    return () => {
      window.removeEventListener('scroll', checkOverlap);
      window.removeEventListener('resize', checkOverlap);
    };
  }, []);

  useEffect(() => {
    console.log('Reached container end:', reachedContainerEnd);
  }, [reachedContainerEnd]);

  useEffect(() => {
    console.log('Header overlap:', isOverlappingHeader);
    console.log('Footer overlap:', isOverlappingFooter);
  }, [isOverlappingHeader, isOverlappingFooter]);



  

  // observer.observe(element1);
  // observer.observe(element2);



  return (
    <div id="build-your-own-set-main" className='grid grid-cols-1 md:grid-cols-8 md:px-8 my-5'>
      <div className='col-span-1 md:col-span-7 px-4'>
        <div className=''>
          { collectionsData.collections.length > 0 ? (
            <div>
              { collectionsData.collections.map((collection, index) => (
                <div key={'collection-card-index-' + index} className="mb-8">

                  { collection.products.length > 0 ? (
                    <div className='grid  grid-cols-2 md:grid-cols-12 mx-4 mt-[6%]  mb-[20%] md:mb-[6%] gap-y-12'>
                      {/* Collection Card */}
                      <ByobCollectionCard collection={collection} index={index} />
                      
                      {/* Product Cards */}
                        { collection.products.map((product, index) => (
                        <ByobProductCards product={product} key={'product-card-index-' + index} index={index} handleAddToTray={handleAddToTray}  trayData={trayData}/>
                      ))}
                    </div>
                  ) : (
                    <div>
                      No products found 
                    </div>
                  ) }
                </div>
              ))}
            </div>
          ) : (
            <div>
              No collections found
            </div>
          )}
        </div>
      </div>
      <div 
        className={`col-span-1 order-first md:order-last mt-0 md:mt-5 ${
          isOverlappingHeader && !reachedContainerEnd ? 'fixed z-[9000]' : 'hidden md:block relative'
        }  md:me-8 md:right-0 md:w-full`}
        style={{ 
          top: isOverlappingHeader && !reachedContainerEnd ? `${topPosition}px` : 'auto',
          bottom: reachedContainerEnd ? '20px' : 'auto'
        }}
        id="byob-tray-container"
      >
        <ByobTray trayData={trayData} setTrayData={setTrayData} handleRemoveFromTray={handleRemoveFromTray} />
      </div>
    </div>
  );
};

export default BuildYourOwnSetMain;